export enum Equipment_Type {
  FLANGE = 'flange',
  PIPE = 'pipe',
  STEAMTRAP = 'steamtrap',
  TANK = 'tank',
  VALVE = 'valve',
  ROTATING_EQ = 'rotatingequ',
  STEAM_TRAP = 'Steam Trap',
  ROTATING_EQUIPMENT = 'Rotating Equipment',
}

export enum MEASUREMENT_TYPE {
  ID_1020 = 1020,
  ID_1048 = 1048,
  ID_1073 = 1073,
  ID_1074 = 1074,
  ID_1068 = 1068,
  ID_1025 = 1025,
  ID_1026 = 1026,
  ID_1077 = 1077,
  ID_1078 = 1078,
  ID_1079 = 1079,
  ID_1080 = 1080,
  ID_1082 = 1082,
}

export enum RotatingEquipment_Type {
  ROTATINGEQ_CENTRIFUGE = 'rotatingeqCentrifuge',
  ROTATINGEQ_COMPRESOR = 'rotatingeqCompressor',
  ROTATINGEQ_MOTOR = 'rotatingeqMotor',
  ROTATINGEQ_FAN = 'rotatingeqFan',
  ROTATINGEQ_GEARBOX = 'rotatingeqGearbox',
  ROTATINGEQ_PUMP = 'rotatingeqPump',
  ROTATINGEQ_OTHER = 'rotatingeqOther',
}

export enum Plant_Structure_Enums {
  BUILDING = 'building',
  LAYER_C = 'c',
  LAYER_D = 'd',
  LAYER_K = 'k',
  LAYER_E = 'e',
  LAYER_L = 'l',
  DELETE = 'delete',
  PLANT = 'plant',
  EDIT = 'edit',
  PLANT_SLASH = 'plant/',
  SENSOR = 'sensor',
  AREA = 'area',
  FLOOR = 'floor',
  SECTION = 'section',
  ZONE = 'zone',
  SCROSSING = 'scrossing',
  ASSOCIATE_EQ = 'associatedeq',
  TECHNICAL_DOCUMENTS = 'technical_documents',
  STEAM_TRAP = 'Steam Trap',
}

export enum CardStatus {
  Alert = 'alert',
  Warning = 'warning',
  OK = 'ok',
  None = 'none',
}

export enum EquipmentStage {
  Initial = 1,
  ImageSelected = 13,
  MarkerPlacement = 15,
}

export enum SensorStages {
  prestep, // 0
  sensor, // 1
  sensorScan, // 15
  sensorUpload,
  sensorUploadCrop,
  edge, // 2
  edgeScan, // 25
  edgeUpload,
  edgeUploadCrop,
  photo, // 3
  photoSensorCrop, // 32
  photoSensorEdit, // 35
  photoAssetCrop, // 36
  photoAssetEdit, // 37
  location, // 4
  end, // 5
}

export enum QrCodeEnums {
  s = 's',
  e = 'e',
}

export enum SettingSubpageEnums {
  Profile = 'profile',
  ChangePassword = 'change-password',
  Language = 'language',
  Metric = 'metric',
  Appearance = 'appearance',
  Notifications = 'notifications',
  TechnicalDocuments = 'technical_documents',
  Help = 'help',
  HelpAbout = 'help/about',
  HelpFaq = 'help/faq',
  Terms = 'terms',
  TermsOfService = 'terms/termsofservice',
  TermsPrivacyPolicy = 'terms/privacypolicy',
  Imprint = 'imprint',
  TermsOfUse = 'terms-of-use',
  DataProtection = 'data-protection',
  ServiceCondition = 'service-conditions',
  NoteForUsResidents = 'note-for-us-residents',
}

export enum DocumentTypeEnum {
  PRODUCT = 'product',
  MANUAL = 'manual',
}

export enum SensorStagesv2 {
  dauSelection,
  prestep,
  gateway,
  outletGateway,
  inletGateway,
  gatewayUpload,
  inletgatewayUpload,
  outletgatewayUpload,
  gatewayUploadCrop,
  inletGatewayUploadCrop,
  outletGatewayUploadCrop,
  gatewayScan,
  inletGatewayScan,
  outletGatewayScan,
  gatewayError,
  inlet,
  inletScan,
  inletUpload,
  inletUploadCrop,
  inletHtstSensor,
  outlet,
  outletScan,
  outletUpload,
  outletUploadCrop,
  outletHtstSensor,
  dau,
  inletDau,
  outletDau,
  dauScan,
  dauUpload,
  dauUploadCrop,
  inletDauScan,
  inletDauUpload,
  inletDauUploadCrop,
  outletDauScan,
  outletDauUpload,
  outletDauUploadCrop,
  connect,
  photo,
  photoSensorCrop,
  photoSensorEdit,
  photoAssetCrop,
  photoAssetEdit,
  location,
  ultrasonic,
  end,
  sensor,
  sensorUploadCrop,
  edge,
}

export enum BUILDING_LAYERS {
  A = 'a',
  B = 'b',
  C = 'c',
  D = 'd',
  E = 'e',
}

export enum filterStatus {
  inactive = 4,
  critical = 3,
  warning = 2,
  working = 1,
  archived = 0,
}

export enum DocumentVariantType {
  Image = 'image',
  File = 'file',
  Default = 'default', // For cases other than 'image' or 'file'
}
export enum DATE_TIME_FORMATE {
  MMDDYYYY = 'MM/dd/yyyy',
  MMDDYYYY_H_MM_A = 'MM/dd/yyyy | h:mm a',
  DDMMYYYY_HH_MM = 'dd-MM-yyyy | HH:mm',
}

export enum ValueRangeType {
  green = 0,
  yellow = 1,
  red = 2,
}

export enum EquipmentType {
  ROTATING_EQUIPMENT = 'Rotating Equipment',
  STEAM_TRAP = 'Steam Trap',
  OTHER = 'Other',
}

export enum INSTALLATION_DATA_KEYS {
  SENSOR_NAME = 'sensor_name',
  SENSOR_NUMBER = 'sensor_number',
  EDGE_DEVICE_NUMBER = 'edge_device_number',
  JUNCTION_BOX_SLOT = 'junction_box_slot',
  INLET_NUMBER = 'inlet_number',
  OUTLET_NUMBER = 'outlet_number',
  DAU_CODE = 'dau_code',
  GATEWAY_CODE = 'gateway_code',
}
export enum MaterialType {
  BiMetallic = 'Bi-metallic',
}
